import { render, staticRenderFns } from "./SetView.vue?vue&type=template&id=61ef5a76&lang=pug"
import script from "./SetView.vue?vue&type=script&lang=js"
export * from "./SetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports